import { ReactNode } from 'react';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import { SpinningLoader } from './Expand';

type ScalePercentage = 0 | 50 | 75 | 90 | 95 | 98 | 100 | 105 | 110 | 125 | 150;

interface FadeTransitionProps {
  children: ReactNode;
  isDisplayed?: boolean;
  className?: string;
  scalePercentage?: ScalePercentage;
  isLoading?: boolean;
  containerClassname?: string;
}

export function FadeTransition({
  scalePercentage = 95,
  isLoading = false,
  containerClassname,
  ...props
}: FadeTransitionProps) {
  return (
    <div className={classNames('h-full relative', containerClassname)}>
      <Transition
        show={props?.isDisplayed && !isLoading}
        enter="transform transition duration-500 ease-in-out"
        enterFrom={`opacity-0 scale-${scalePercentage}`}
        enterTo="opacity-100 scale-100"
        leave="transform transition duration-[100ms] ease-in-out"
        leaveFrom="opacity-100 scale-100"
        leaveTo={`opacity-0 scale-${scalePercentage}`}
        className={props.className}
      >
        {props.children}
      </Transition>
      {isLoading && (
        <SpinningLoader
          loadingClassname={classNames(
            'transition-all opacity-0 absolute inset-center',
            isLoading && 'opacity-100',
          )}
        />
      )}
    </div>
  );
}
